<template>
  <modal
    name="vehicle-modal"
    :height="isMobile ? '100%' : 'auto'"
    :width="isMobile ? '100%' : '80%'"
    :scrollable="true"
  >
    <!-- Modal Header -->
    <div
      class="pb-2 pt-4 pr-4 pl-4 border-b mb-4 border-gray-200 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 2xl:h-24 flex items-center justify-between"
    >
      <h4 class="text-xl font-semibold">ÖNERİLEN ARAÇ DETAYI</h4>
      <button
        type="button"
        class="px-3 text-lg"
        @click="$modal.hide('vehicle-modal')"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Modal Content -->
    <div
      class="pb-4 px-4 pt-2 xl:flex items-start justify-between 2xl:mb-20 mb-8 "
      :style="{ height: 'auto' }"
    >
      <!-- Map Section -->
      <div class="w-full xl:w-1/2 mb-4 xl:mb-0">
        <mapItem v-if="detail" :item="detail" height="35vh" />
        <div class="mt-2">
          <label class="block font-bold text-md mb-2"
            >Muayene Bitiş Tarihleri</label
          >

          <RecommendationDetail
            label="Araç Muayene Tarihi"
            :value="
              formattedEndDate(detail?.recomendation?.vehicleInspectionEndDate ? detail?.recomendation?.vehicleInspectionEndDate :detail?.vehicleInspectionEndDate )
            "
            :date="true"
          />
          <RecommendationDetail
            label="Dorse Muayene Tarihi"
            :date="true"
            :value="formattedEndDate(detail?.recomendation?.inspectionEndDate ? detail?.recomendation?.inspectionEndDate : detail?.inspectionEndDate)"
          />
          <RecommendationDetail
            label="Araç ADR Muayene Tarihi"
            :value="formattedEndDate(detail?.recomendation?.vehicleAdrEndDate ? detail?.recomendation?.vehicleAdrEndDate : detail?.vehicleAdrEndDate)"
            :date="true"
          />
          <RecommendationDetail
            label="Dorse ADR Muayene Tarihi"
            :value="formattedEndDate(detail?.recomendation?.dorseAdrEndDate ? detail?.recomendation?.dorseAdrEndDate : detail?.dorseAdrEndDate)"
            :date="true"
          />
          <RecommendationDetail
            label="SRC-5 Belgesi Bitiş Tarihi"
            :value="formattedEndDate(detail?.recomendation?.srcEndTime ? detail?.recomendation?.srcEndTime : detail?.srcEndTime)"
            :date="true"
            :lastItem="true"
          />
        </div>
      </div>

      <!-- Recommendation Details -->
      <div class="w-full xl:w-1/2 pb-4 px-4 space-y-2">
        <label class="block font-bold text-lg mb-2">ÖNERİ NEDENLERİ</label>
        <RecommendationDetail label="Araç Sahipliği" :value="vehicle()" />
        <RecommendationDetail
          label="Yükleme Noktasına Yakınlık"
          :value="`${detail?.recomendation?.distancePriority} KM`"
        />
        <RecommendationDetail
          v-if="(detail?.polygonName && detail?.polygonScore != undefined) || (detail?.recomendation?.polygonName && detail?.recomendation?.polygonScore != undefined)"
          label="Araç Bekleme Skoru"
          :value="`${detail?.polygonScore || detail?.recomendation?.polygonScore}`"
        />

        <RecommendationDetail
          v-if="(detail?.polygonName && detail?.polygonScore != undefined) || (detail?.recomendation?.polygonName && detail?.recomendation?.polygonScore != undefined)"
          :label="getVehicleQueue()"
          :value="`${detail?.rankInPolygon || detail?.recomendation?.rankInPolygon}`"
        />

        <RecommendationDetail
          label="Müşteri Önceliği"
          :value="detail?.recomendation?.customerPriority"
        />

        <RecommendationDetail
          label="Araç Kapasitesi"
          :value="detail?.recomendation?.capacity | formatCapacity"
        />

        <RecommendationDetail
          label="Yük Miktarı"
          :value="formatLoad(detail)"
        />

        <RecommendationDetail
          label="Araç Muayene Bitiş Tarihi"
          :iconClass="
            detail?.recomendation?.isInspectionAvailable
              ? 'fas fa-check text-green-500'
              : 'fas fa-times text-red-500'
          "
        />

        <RecommendationDetail
          label="Araç Müsaitliği"
          :iconClass="
            detail?.recomendation?.isVehicleAvailable
              ? 'fas fa-check text-green-500'
              : 'fas fa-times text-red-500'
          "
        />

        <RecommendationDetail
          label="Dorse / Ürün Uygunluğu"
          :iconClass="
            detail?.recomendation?.dorseAvailable
              ? 'fas fa-check text-green-500'
              : 'fas fa-times text-red-500'
          "
        />

        <RecommendationDetail
          label="ADR Gereksinimini Karşılıyor mu?"
          :iconClass="
            detail?.recomendation?.isADRCompatible
              ? 'fas fa-check text-green-500'
              : 'fas fa-times text-red-500'
          "
        />

        <RecommendationDetail
          label="Son Yük Uygunluğu?"
          title="Aracın taşıdığı son yük mevcut yük ile aynı mı veya daha önce hiç ürün taşımadı mı"
          :iconClass="
            detail?.recomendation?.lastProductAvailable === 1
              ? 'fas fa-check text-green-500'
              : detail?.recomendation?.lastProductAvailable === 2
              ? 'fas fa-times text-red-500'
              : 'fas fa-exclamation-triangle text-yellow-500'
          "
        />

        <!-- Müşteri Bazlı Uyumsuz Yük Uyarısı -->
        <div
          v-if="detail?.recomendation?.isIncompatible"
          class="text-xs border border-orange-200 bg-orange-100 p-2 rounded-md mt-1"
        >
          <i class="fas fa-exclamation-triangle mr-2 text-orange-700"></i>
          <span class="font-semibold">Müşteri Bazlı Uyumsuz Yük:</span>
          <div class="mt-1 ml-5">
            {{ detail?.recomendation?.incompatibilityReason }}
          </div>
          <div v-if="detail?.recomendation?.rejectedProduct" class="mt-1 ml-5 font-medium">
            Yasaklı Ürün: <span class="text-orange-800">{{ detail?.recomendation?.rejectedProduct }}</span>
          </div>
        </div>

        <RecommendationDetail
          label="Araç Temiz mi?"
          :iconClass="
            detail?.recomendation?.isWashing == 2
              ? 'fas fa-check text-green-500'
              : detail?.recomendation?.isWashing == 3
              ? 'fas fa-exclamation-triangle text-yellow-500'
              : 'fas fa-times text-red-500'
          "
        />
        <div
          v-if="detail?.recomendation?.isWashing == 1 && detail?.washPointNotExist"
          class="text-xs border bg-gray-50 p-1 rounded-md"
          >
          <i class="fas fa-info-circle mr-2 text-yellow-500"></i>
            Yıkama noktalarında son yükü  yıkayabilecek bir nokta mevcut değil.
        </div>
        <div>
          <div 
            v-if="detail?.isVehicleRentAndIncludePolygon"
            class="text-xs border border-red-200  bg-red-100 p-1 rounded-md whitespace-nowrap w-full"
            >
            <i class="fas fa-info-circle mr-1 text-yellow-700"></i>
             Araç kiralık ve bir pentegrama dahil olduğu için yıkama maliyeti dahil edilmemiştir.
          </div>
          <div 
            v-if="detail?.recomendation?.isWashing == 1 && detail?.recomendation?.lastProductAvailable === 3"
            class="text-xs border border-red-200 bg-red-100 p-1 rounded-md mt-1"
            >
            <i class="fas fa-info-circle mr-2 text-yellow-700"></i>
             Araç kirli fakat aracın son yük bilgisi bilinmediği için yıkama maliyeti dahil edilmemiştir.
          </div>
        </div>
        <RecommendationDetail
          v-if="detail.orderAmount <= 30"
          label="Araç Tonajı Uygun Mu?"
          :iconClass="
            detail?.recomendation?.isTonnageSuitable
              ? 'fas fa-check text-green-500'
              : 'fas fa-times text-red-500'
          "
        />

        <!-- Equipment Compatibility Section -->
        <!-- Sadece "Ekipman ile Planla" aktif ise göster -->
        <RecommendationDetail
          v-if="detail?.isEquipmentBased && detail?.recomendation?.hasEquipmentRequirements"
          label="Gerekli Ekipman Uygunluğu"
          :iconClass="
            equipmentCompatibleStatus
              ? 'fas fa-check text-green-500'
              : 'fas fa-times text-red-500'
          "
        />


        <!-- Missing Equipment Details -->
        <!-- Sadece "Ekipman ile Planla" aktif ise göster -->
        <div
          v-if="detail?.isEquipmentBased && detail?.recomendation?.missingRequiredEquipment && detail?.recomendation?.missingRequiredEquipment.length > 0"
          class="text-xs border border-red-200 bg-red-100 p-2 rounded-md mt-2"
        >
          <i class="fas fa-exclamation-triangle mr-2 text-red-500"></i>
          <span class="font-semibold">Eksik Zorunlu Ekipmanlar:</span>
          <ul class="mt-1 ml-4">
            <li v-for="(item, index) in detail?.recomendation?.missingRequiredEquipment" :key="index">
              {{ item.category }} ({{ item.required_quantity }} adet)
            </li>
          </ul>
        </div>

        <!-- Required Equipment Compatibility Status -->
        <!-- Sadece "Ekipman ile Planla" aktif ise göster -->
        <div
          v-if="detail?.isEquipmentBased && hasMatchedEquipment"
          class="text-xs border border-green-200 bg-green-100 p-2 rounded-md mt-2"
        >
          <i class="fas fa-check-circle mr-2 text-green-500"></i>
          <span class="font-semibold">Gerekli Ekipman Uygunluğu:</span>
          <ul class="mt-1 ml-4">
            <li v-for="(item, index) in actuallyMatchedEquipment" :key="'matched-' + index">
              {{ item.category }}: {{ parseInt(item.available_quantity) }} adet ✓
            </li>
          </ul>
        </div>

        <!-- Actually Insufficient Equipment Details (where available < required) -->
        <!-- Sadece "Ekipman ile Planla" aktif ise göster -->
        <div
          v-if="detail?.isEquipmentBased && hasInsufficientEquipment"
          class="text-xs border border-yellow-200 bg-yellow-100 p-2 rounded-md mt-2"
        >
          <i class="fas fa-info-circle mr-2 text-yellow-500"></i>
          <span class="font-semibold">Yetersiz Zorunlu Ekipmanlar:</span>
          <ul class="mt-1 ml-4">
            <li v-for="(item, index) in actuallyInsufficientEquipment" :key="'insufficient-' + index">
              {{ item.category }}: Mevcut {{ parseInt(item.available_quantity) }}/{{ parseInt(item.required_quantity) }} adet
            </li>
          </ul>
        </div>

        <!-- Missing Optional Equipment Details -->
        <!-- Sadece "Ekipman ile Planla" aktif ise göster -->
        <div
          v-if="detail?.isEquipmentBased && detail?.recomendation?.missingOptionalEquipment && detail?.recomendation?.missingOptionalEquipment.length > 0"
          class="text-xs border border-blue-200 bg-blue-100 p-2 rounded-md mt-2"
        >
          <i class="fas fa-info-circle mr-2 text-blue-500"></i>
          <span class="font-semibold">Eksik Opsiyonel Ekipmanlar:</span>
          <ul class="mt-1 ml-4">
            <li v-for="(item, index) in detail?.recomendation?.missingOptionalEquipment" :key="index">
              {{ item.category }} ({{ item.required_quantity }} adet)
            </li>
          </ul>
        </div>

        <!-- Equipment Summary -->
        <!-- Sadece "Ekipman ile Planla" aktif ise göster -->
        <div
          v-if="detail?.isEquipmentBased && detail?.recomendation?.hasEquipmentRequirements"
          class="text-xs border border-gray-200 bg-gray-100 p-2 rounded-md mt-2"
        >
          <i class="fas fa-clipboard-check mr-2 text-gray-500"></i>
          <span class="font-semibold">Ekipman Özeti:</span>
          <p class="mt-1">{{ equipmentSummaryText }}</p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
//npm
import moment from "moment";

//Global Components
import diffInput from "@/components/general/diffInput.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";

// local components
import mapItem from "./map.vue";
import RecommendationDetail from "./recommendationDetail.vue";
export default {
  name: "vehicle-modal",
  props: ["detail"],
  components: {
    RecommendationDetail,
    diffInput,
    asyncBtn,
    mapItem,
  },
  data() {
    return {
      customer: "",
      hakedisKilometer: "",
    };
  },
  computed: {
    actuallyMatchedEquipment() {
      if (!this.detail?.recomendation?.insufficientRequiredEquipment) return [];
      return this.detail.recomendation.insufficientRequiredEquipment.filter(
        item => parseInt(item.available_quantity) >= parseInt(item.required_quantity)
      );
    },
    actuallyInsufficientEquipment() {
      if (!this.detail?.recomendation?.insufficientRequiredEquipment) return [];
      return this.detail.recomendation.insufficientRequiredEquipment.filter(
        item => parseInt(item.available_quantity) < parseInt(item.required_quantity)
      );
    },
    hasMatchedEquipment() {
      return this.actuallyMatchedEquipment.length > 0;
    },
    hasInsufficientEquipment() {
      return this.actuallyInsufficientEquipment.length > 0;
    },
    equipmentCompatibleStatus() {
      // Eğer eksik zorunlu varsa veya gerçekten yetersiz varsa false
      if (this.detail?.recomendation?.missingRequiredEquipment?.length > 0) return false;
      if (this.hasInsufficientEquipment) return false;
      // Hiç zorunlu ekipman yoksa veya hepsi uygunsa true
      return true;
    },
    equipmentSummaryText() {
      const details = [];

      // Eksik zorunlu ekipmanlar
      if (this.detail?.recomendation?.missingRequiredEquipment?.length > 0) {
        const missingCategories = this.detail.recomendation.missingRequiredEquipment.map(p => p.category);
        details.push(`Eksik zorunlu: ${missingCategories.join(', ')}`);
      }

      // Gerçekten yetersiz zorunlu ekipmanlar (computed property kullanarak)
      if (this.hasInsufficientEquipment) {
        const insufficientDetails = this.actuallyInsufficientEquipment.map(p =>
          `${p.category}: ${parseInt(p.available_quantity)}/${parseInt(p.required_quantity)}`
        );
        details.push(`Yetersiz zorunlu: ${insufficientDetails.join(', ')}`);
      }

      // Eksik opsiyonel ekipmanlar
      if (this.detail?.recomendation?.missingOptionalEquipment?.length > 0) {
        const optionalCount = this.detail.recomendation.missingOptionalEquipment.length;
        const totalOptional = this.detail.recomendation.missingOptionalEquipment.length +
                             (this.detail.recomendation.insufficientOptionalEquipment?.length || 0);
        details.push(`${optionalCount}/${totalOptional} opsiyonel ekipman eksik`);
      }

      return details.length > 0 ? details.join(", ") : "Tüm ekipmanlar uyumlu";
    }
  },
  methods: {
    
    formattedEndDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : "-";
    },
    formatLoad(detail){
      if(detail.unitType=="SEFER"){
         return detail.tonnage + " SEFER";
      }
      if (typeof detail.tonnage === "number" && detail.tonnage >= 1000) {
        return detail.tonnage / 1000 + " TON";
      } else {
        return detail.tonnage + " TON";
      }
    },
    vehicle() {
      if (
        this.detail?.isRent === 1||
        this.detail?.vehicle?.isRent === 1 ||
        this.detail?.haveType === 1
      ) {
        return "Kiralık ";
      } else if (
        this.detail?.vehicle?.isRent === 2 ||
        this.detail?.haveType === 2 ||
        this.detail?.isRent === 2
      ) {
        return "Özmal";
      } else {
        return "-";
      }
    },
    getVehicleQueue(){
      const detail=this.detail;
      return 'Araç Bekleme Sırası ('+ ( detail.polygonName != undefined ? detail.polygonName : detail.recomendation.polygonName ) +')'
    }
  },
  filters: {
    formatCapacity(capacity) {
      if (typeof capacity === "number" && capacity >= 1000) {
        return capacity / 1000 + " TON";
      } else {
        return capacity + " TON";
      }
    },
  },
};
</script>
